<template>
  <div class="edit-module-content-main">
    <div class="edit-editor-title">
      <div class="edit-back" @click="back">
        <i class="iconfont iconchevron-left"></i>返回
      </div>
      <div class="edit-module-name" :class="[currentInfo.data && currentInfo.data.id ? 'pointer' : 'default']"
           @click="currentInfo.data && currentInfo.data.id && editModuleTitle()">
        <span class="text-overflow">{{title || cvDetail.submodule_info[`${currentInfo.type}_title`]}}</span>
        <i style="color: #C2C2C2;" class="pointer iconfont iconedit-" @click="editModuleTitle"
           v-if="showEditModuleTitle() || isMentorEditor"></i>
      </div>
      <button class="edit-module-save" @click="debounceSave" :disabled="!infoNotEmpty(formData, currentInfo.type)">保存
      </button>
    </div>
      <el-collapse-transition>
        <w-form-data v-show="!autoModel" ref="WForm" :form-data="formData" :form-list="formList" :picker-options="pickerOptions"
                     :degree-data="degreeData" @update-form="updateForm"
                     @change="endAtChange" @selectCity="selectCity" @selectMajor="selectMajor"
                     @selectDegree="selectDegree" @selectUniversity="selectUniversity" @schoolTagChange="schoolTagChange">
        </w-form-data>
      </el-collapse-transition>
    <div class="text-editor-content">
      <div class="flex justify-s-b">
        <div class="edit-module-item-name margin-top-24 flex-c" style="width: 100%;justify-content:space-between;">
          经历描述
          <button class="ai-cvs-entry" @click="handleClickAiBtn">AI 简历润色</button>
        </div>
        <!-- <div class="edit-module-item-name margin-top-24 flex-c cursor_p common-container" :class="{'common-disabled': !showCommonTips}" v-if="currentInfo.type === 'works'" @click="addCommonExp()">
          <span class="iconfont iconadd-circle" />
          <span class="common-tips">再写一段同公司经历</span>
        </div> -->
        <!-- <p class="margin-top-24" v-if="backUpInfo.type === 'works'">
          <span class="auto-model">开挂模式</span>
          <el-switch active-color="#13ce66" inactive-color="#9C9C9C" @change="handleClickAuto" :value="autoModel"/>
        </p> -->
      </div>
      <div class="position-r">
        <text-editor
          :form-data="formData"
          @useOptimizationContent="useOptimizationContent"
          @handleSaveCurrentForm="debounceSave"
        ></text-editor>
      </div>
      <el-collapse-transition>
        <cv-auxiliary v-show="!autoModel" @on-select="handleClickAutoContentItem">
          <div slot="operation" class="module-delete" @click="deleteExperience" v-show="isDelExperience">
            <i class="iconfont icontrash-"></i>
            <span>删除这段经历</span>
          </div>
        </cv-auxiliary>
      </el-collapse-transition>
      <transition name="el-zoom-in-top">
        <cv-auto-write v-show="autoModel && backUpInfo.type === 'works'" :key-word="autoKeyword" @on-select="handleClickAutoContentItem"/>
      </transition>
    </div>
    <!--    <div class="edit-editor-btn">-->
    <!--      <div>-->
    <!--        <div class="edu-item" @click="deleteExperience" v-show="experienceInfos.length > -1">-->
    <!--          <i class="iconfont icontrash-"></i>-->
    <!--          <span>删除这段经历</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="btn-box">-->
    <!--        <button class="close-btn" @click="back">取消</button>-->
    <!--        <button class="complete-btn" @click="debounceSave" :disabled="!infoNotEmpty(formData, currentInfo.type)">保存</button>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
	import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
	import moment from 'moment'
	import WFormData from '@/components/editor/w-form-data'
	import textEditor from './text-editor'
	import richText from '@/components/base/richText'
	import rules from '@/assets/json/rules'
	import cvAuxiliary from './cv-auxiliary'
	import { cvMixin, dealCvDataMixin } from '../../../../../assets/js/mixins'
	import editorModule from '../../../../../assets/json/editor-module.json'
	import api from '../../../../../api'
	import { setEditNumLocalStorage, debounce, contrastContent,  punctuationText} from '@/assets/js/util'
  import CvAutoWrite from "./cv-auto-write"
  import tinymce from 'tinymce/tinymce'
  import {isFinite} from "lodash";
	export default {
		name: 'baseModuleForm',
		mixins: [ cvMixin, dealCvDataMixin ],
		data () {
			return {
				debounceSave: null,
				isSave: false,
				title: '', // 模块标题，只在修改标题后使用
        pickerOptions: {},
				oldFormData: {},
				degreeData: {},
        isTimer: null,//是否
        oldContent: "",//旧的描述
        isAutoWriteing: false,//是否正在自动填充
        autoKeyword: "",//自动写简历的关键字
        normalSave: true,  // 是否点击保存按钮保存（排除工作经历子经历）
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvInfo', 'editModuleData' ]),
			...mapState('cvs', [ 'cv', 'editorCvToken', 'highlightShow', 'section_titles' ]),
			...mapState('editor', [ 'cvDetail', 'cvToken', 'currentInfo', 'backUpInfo', 'profile', 'edus', 'orgs', 'works', 'checkCloseEditModule', 'autoModel', 'postId', 'companyIsDisabled', 'quitResumeEditor' ]),
			...mapState('experience', [ 'experienceList' ]),
			...mapGetters('experience', [ 'hasExperienceList' ]),
      // 显示添加子工作经历的提示样式
      showCommonTips() {
        let { company, start_at, end_at, title, dept, city, description } = this.formData
        return company && ((start_at && end_at) || title || dept || city || description)
      },
			// 当前编辑的页面的数据
			formList () {
				let { type } = this.currentInfo
				return JSON.parse(JSON.stringify(editorModule[`${ type }Form`]))
			},
			// 当前简历里面的 edus, works, orgs 的经历
			experienceInfos () {
				let { type } = this.currentInfo
				return this[type]
			},
      isDelExperience () {
        let { type } = this.currentInfo;
        // 当前模块是否还有其他数据 && 是编辑时
        return this.cvDetail['submodule_info'][`${type}_ids`].length && this.currentInfo.operation === 'edit';
      },
			// 当前编辑的模块经历库里面的内容
			experience () {
				let { type } = this.currentInfo
				return this.experienceList[type]
			},
			isMentorEditor () {
				return window.location.href.includes('mentor')
			}
		},
		mounted () {
			this.initDateOptions()
			this.initFormData()
		},
		components: {
			richText,
			textEditor,
			WFormData,
			cvAuxiliary,
      CvAutoWrite
		},
		watch: {
      currentInfo: {
        handler (newValue) {
          // 教育经历模块 选择时间 不需要显示至今按钮
          if (newValue.type === 'edus') {
            this.pickerOptions = {}
          } else {
			      this.initDateOptions()
          }
        },
        deep: true
      },
			checkCloseEditModule: function (state) {
				if (state) {
					this.back()
					//设置是否需要取消当前编辑状态，并返回
					setTimeout(() => {
						this.setCheckCloseEditModule(false)
					}, 10)
				}
			},
      'formData.title'(value) {
			  if(value && value.length > 0){
          this.setIsShowAutoWriteError(false)
        }
      },
      'formData.description'(value) {
        let reg = /<\/?.+?\/?>/g;
			  if(!this.autoModel) {
          this.oldContent = value || ''
          return
        };
			  if(this.isAutoWriteing) return;
			  if(this.isTimer){
			    clearTimeout(this.isTimer)
        }
			  this.isTimer = setTimeout(()=>{
          this.autoKeyword = contrastContent(value, this.oldContent || '')
          this.oldContent = value || ''
        },800)
      },
      autoModel(value){
			  if(!value) {
			    this.autoKeyword = ""
        }
      },
      // 监听是否退出模块编辑
      quitResumeEditor(value){
			  if(value) {
          // 还原状态
			    this.setQuitResumeEditor(false);
          // 执行退出模块编辑
          this.back();
        }
      },
		},
		created () {
			this.debounceSave = debounce(this.save, 300)
		},
		methods: {
			...mapActions('cvsEditor', [ 'createdOrg', 'editOrg' ]),
			...mapMutations('editor', [ 'setCurrentInfo', 'setModuleData', 'setCheckCloseEditModule', 'setIsShowAutoWriteError', 'setAutoModel', 'setPostId', 'updateCompanyDisabled', 'setCvDetail', 'setBackUpProfile', 'setBackUpFormatInfo', 'updateWorkHasSubItem', 'updateCommonIndex', 'setQuitResumeEditor' ]),
			...mapActions('editor', [ 'getGroupsEntry', 'updateExperience', 'createExperience', 'createCvDetail', 'updateCvDetail', 'setIsSendRequest', 'getPostLevelId', 'getAutoResumeWriteList' ]),
			...mapMutations('experience', [ 'updateExperienceModule', 'deleteExperienceSelect', 'updateExperienceTitleName','updateSidebarOption', 'updateCurrentExperienceType' ]),
			...mapActions('manage', [ 'getMenuList' ]),
      showAIDialog () {
        // this.$store.dispatch('app/setAlertData', {
        //   show: true,
        //   type: 'ai-cvs'
        // })
      },
      // 添加相同公司子经历
      addCommonExp() {
        if (!this.showCommonTips) return
        this.$message.info('再写一段同公司经历')
        this.isCommon = true
        this.commonState = true
        // 设置简历排版为双行标题/地点优先
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
        let newCvDetail = {...cvDetail, format_info: {...cvDetail.format_info, body_format: 'two_line', format_priority: 'city'}}
        this.setCvDetail(newCvDetail)
        this.cvFormat(newCvDetail)
        this.save(true)
      },
      // 修改简历排版
      async cvFormat(newCvDetail) {
        try {
          let data = {
            operation_type: 'update_format_info',
            format_info: newCvDetail.format_info
          }
          let res = {}
          if (this.isMentorEditor) {
            res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
          } else {
            res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
          }
          //检测是否有profile数据
          // if (this.profile.id && this.controlOption === 1) {
          // 	let profileRes = await api.cvsEditor.editProfile(this.cvToken, this.profile)
          // }
          if (res.code === 1000) {
            // this.$message.success('保存成功')
            //修改基本信息备份基本信息设置
            this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)))
            //修改简历设置备份
            this.setBackUpFormatInfo(JSON.parse(JSON.stringify(newCvDetail.format_info)))
            //当前右侧大tab选择类型置为空
            // this.updateSidebarOption('');
          } else {
            this.$message.success(res.message)
          }
        } catch (error) {
          this.$message.success('修改失败')
        }
      },
			//是否显示标题
			showEditModuleTitle () {
				let isKind = this.cvDetail.basic_info.kind === 'sample' || this.cvDetail.basic_info.kind === 'template'
				return !isKind
			},
			// 获取check时候的title
			getRulesTitle (title, check) {
				for (let i = 0; i < rules.rules.length; i++) {
					if (rules.rules[i].name === title || (check && check.name === rules.rules[i].name)) {
						return rules.rules[i].title
					}
				}
				return '提示'
			},
			// change
			change () {
				// console.log(JSON.stringify(this.formData, null, 4))
			},
			// 更新或者创建经历
			async experienceChange (operation) {
				let valid = this.$refs['WForm'].formValidate()
				if (!valid) return false
				let { type } = this.currentInfo
				return new Promise( async (resolve, reject) => {
          let res = {}
          let payload = {
            ...this.formData,
            start_at: this.formData.start_at ? moment.utc(this.formData.start_at) : null,
            end_at: this.formData.end_at ? moment.utc(this.formData.end_at) : null,
            lang: this.cvDetail.basic_info.lang
          }
          // 编辑
          if (operation === 'update') {
            res = await this.updateExperience({ type, payload })
            // console.log(res,"======================>ressss")
            // console.log(payload, "========================>payload")
            // console.log(type, "========================>type")
            if (res.code === 1000) {
              await this.cvDetailChange(res.data[type])
            }
          } else if (operation === 'create') {
            let currentInfoOperation = ''
            //如果进入时是编辑，但是拒绝同步，直接更新
            if (this.currentInfo.operation === 'edit') {
              currentInfoOperation = 'add'
            }
            delete payload.id
            if (type === 'edus' && !payload.major_id) {
              payload.major_id = null
            }
            // 是否是子经历(添加子经历按钮添加 && 当前的 index > -1)
            // if (this.commonState && this.commonIndex > 0) {
            //   payload.is_sub_item = true
            // }
            res = await this.createExperience({ type, payload })
            if (res.code === 1000) {
              await this.cvDetailChange(res.data[type], currentInfoOperation)
              // 同公司工作经历的子经历保存完之后修改状态更新排版 disabled 状态
              if (payload.is_sub_item) {
                this.updateWorkHasSubItem(true)
              }
            } else if (res.code === 80143) {
              // 显示超出模块最大限制
              this.showModuleMaxTips()
            }
          }
          this.getGroupsEntry()

          resolve(res)
        })
			},
      // 检查经历保存时是否需要替换,arr: 所有建立列表  data: 需要检查的数据   index: 下标
      checkCvInstance(arr, data, index) {
        // 空数据和保存之后的数据相同，执行替换
        if (arr[index].title === data.title && arr[index].company === data.company && arr[index].is_sub_item === data.is_sub_item) {
          arr.splice(index, 1, data)
          return true
        } else {
          return false
        }
      },
			// 更新或者创建简历
			async cvDetailChange (data, currentInfoOperation) {
				let { type, operation } = this.currentInfo
				let { submodule_info, basic_info, format_info, basic_info: { kind }, submodule_info: { sections_position } } = this.cvDetail
				let ids = submodule_info[`${ type }_ids`]
				let infos = JSON.parse(JSON.stringify(this.experienceInfos))
				let position = JSON.parse(JSON.stringify(sections_position))
				const isCreate = kind === 'template' || kind === 'sample' //是否需要创建简历
				// 找到简历中当前 id 所在位置
				const infoIndex = ids.findIndex(item => item === this.formData.id)
				// 判断当前经历是需要替换 id 还是 往 ids 里面push
				const replace = this.formData.id !== this.backUpInfo.data.id || this.formData.kind === 'sample' || infoIndex > -1
				// 寻找当前模块是否在sections_position中
				const moduleIndex = sections_position.findIndex(item => item.type === type)
				let res = {}
				// 如果当前简历里面没有此模块，则往section_positions里面push当前模块
				if (moduleIndex === -1) {
					position.push({
						type,
						info_ids: [],
						id: null
					})
				}
				replace ? ids[infoIndex] = data.id : this.commonIndex > -1 ? ids.splice(this.commonIndex, 0, data.id) : ids = [ ...ids, data.id ]
				let payload = {
					submodule_info: {
						...submodule_info,
						sections_position: position,
						[`${ type }_ids`]: Array.from(new Set(ids)).filter(item => !!item)
					},
					operation_type: isCreate ? '' : 'update_submodule_info'
				}
				console.log('isCreate=>>>', isCreate)
				// if (window.location.href.includes('mentor')) {
				// 	// 导师编辑只更新简历时间，第一版导师不可在简历里面添加内容
				// 	await this.updateCvDetail({ operation_type: 'touch' })
				// }
        return new Promise( async (resolve, reject) => {

          if (isCreate) {
            payload = { ...payload, basic_info: { ...basic_info }, format_info }
            res = await this.createCvDetail({
              payload,
            })
          } else {
            res = await this.updateCvDetail({ ...payload, saveModule: true })
          }
          if (res.code === 1000) {
            if (operation === 'module' || operation === 'add') {
              if (this.commonIndex > -1) {
                // 新的子经历（后端返回带ID的经历）替换原来数据中没有ID的子经历
                if (this.commonIndex === 0 && !infos[0].id) {
                  infos.splice(this.commonIndex, 1, data)
                } else {
                  if (!this.checkCvInstance(infos, data, this.commonIndex)) {
                    infos.splice(this.commonIndex + 1, 1, data)
                  }
                }
              } else {
                infos[infos.length - 1] = data
              }
            } else if (replace) {
              const index = infos.findIndex(item => item.id === this.backUpInfo.data.id)
              infos[index] = data

            } else {
              infos = [ ...infos, data ]
            }
            //同步数据
            // if ((!this.isCommon || operation === 'add') && type === 'works') {
            //   this.setModuleData({ type, info: infos })
            // }
            this.setModuleData({ type, info: infos })
            //更新经历库模块信息
            this.updateExperienceModule({
              key: type,
              info: data,
              operation: currentInfoOperation || operation,
              title: this.title || this.currentInfo.title,
              updateBackUp: true,
            })
            //整理模块管理模块选中状态
            this.getMenuList()
            if (this.commonIndex < 0 || this.normalSave) {
              //重置编辑模块默认数据
              this.resetEditState(true)
            }
            this.setDealCheck(true)
            if (this.saveFormDataByDialog) {
              this.saveFormDataByDialog()
              this.setFormDataFn(null)
              // commit('setFormDataFn', null)
            }
          }
          resolve(res)
        })
			},
      // 点击子经历保存之后操作逻辑
      saveAfter(res, isCommon) {
        if (res.code === 1000 && this.currentInfo.type === 'works') {
          if (isCommon && typeof isCommon !== 'object') {

            // 创建的主工作经历模块，点了再写一段, 小于0，重新获取下一个所在位置
            // if(this.commonIndex < 0 && res.data.works){
            //   let infos = JSON.parse(JSON.stringify(this.experienceInfos))
            //   let works = JSON.parse(JSON.stringify(this.works))
            //   let nextIndex = infos.findIndex(item => item.id === res.data.works.id);
            //   console.log('重新获取下一个所在位置=>>>>>',nextIndex, infos, works, res.data.works)
            // }
            this.updateCompanyDisabled(true)
            // 保存成功之后下标 + 1
            this.updateCommonIndex(this.commonIndex + 1)
            // 编辑情况下点击了添加子经历，此时没有 res.data.works
            let data = {company: res.data?.works?.company || this.formData.company, description: '', is_sub_item: true}
            this.editModule(data, {type: 'works'}, 'add', '', isCommon, !!res.data?.works)
            this.commonState = false
          } else {
            // 保存成功之后下标 + 1
            this.updateCommonIndex(-1)
            this.setCurrentInfo({
              operation: '',
              type: '',
              data: {}
            })
          }
        } else {
          this.setCurrentInfo({
            operation: '',
            type: '',
            data: {}
          })
        }
      },
			// 保存  isCommon: 是否保存的相同公司的工作子经历
			async save (isCommon) {
        if (typeof isCommon !== 'object') {
          this.normalSave = false
        } else {
          this.normalSave = true
        }
        // 判断当前经历是否能保存
        let { company, city, description, dept, title, start_at, end_at, is_sub_item } = this.formData
        if (this.currentInfo.type === 'works' && is_sub_item && !(company && (city || description || dept || title || (start_at && end_at)))) {
          this.$message.error('请先完善经历信息')
          return
        }
        // this.updateCompanyDisabled(false)
        this.setIsShowAutoWriteError(false)
				// if (this.isSave) return
				// this.isSave = true
				setEditNumLocalStorage()
				// this.formData.description = this.formData.description ? this.formData.description.replace(/(?<= )class=".*?"/gi, '').replace(/<div/gi, '<p').replace(/\/div>/gi, '\/p>') :
				// 	null
				let { id, mentor_id } = this.formData
				// 找到在经历库中当前 id 所在的位置
				const experienceIndex = this.experience ? this.experience.findIndex(item => item.id === id) : -1
				/*
        1. experienceIndex 大于 -1 的话说明当前经历是用户已有经历，需要对比是否修改
         **/
        let res = {}

        console.log(experienceIndex, 'experienceIndex')
				if (mentor_id && this.isMentorEditor) {
					this.experienceChange('update')
				} else if (experienceIndex > -1) {
					let experienceInfo = this.experience[experienceIndex]
					if (this.contrastInitData(this.formData, experienceInfo)) {
						if (await this.verifyFormData(id)) {
							const alertData = {
								...this.alertData,
								messageTitle: '修改同步提示',
								confirmButtonText: '同步',
								cancelButtonText: '不同步',
								messageContent: `<p>此段经历在其他简历中被引用，</p><p style="color: #FF453E">是否同步修改到其他简历？</p>`,
								confirm: async close => {
									this.experienceChange('update')
									close()
								},
								cancel: close => {
									this.experienceChange('create')
									close()
								},
							}
							this.setAlertData(alertData)
						} else {
							res = await this.experienceChange('update')
						}
					} else {
						// 如果和编辑时的 id 一致，就直接关闭窗口
						if (this.formData.id === this.backUpInfo.data.id) {
							let bool = this.resetEditState()
              if (bool) {
                res = {code: 1000}
              }
						} else {
							res = await this.updateCvDetail({ ...this.formData, saveModule: true })
						}
					}
				} else {
					res = await this.experienceChange('create')
				}
        // 提交保存模块监听
        this.$eventBus.$emit("saveEditorModule", this.currentInfo.type)
        if (this.commonIndex > -1 && !this.normalSave) {
          setTimeout(() => {
            this.saveAfter(res, isCommon)
          }, 500);
        }
				// this.experienceChange('update')
			},
			// 判断经历有没有被引用
			async verifyFormData (id) {
				let { type } = this.currentInfo
				let res = await api.cvsEditor[`${ type }Verify`](id)
				if (res.code === 1000) {
					return res.data.imported
				} else {
					this.$message.error(res.message)
					return false
				}
			},
			// 修改模块标题
			async editModuleTitle () {
				//判断是否为导师页面
				let pathFirstWord = this.$route.path.substr(1, 6)
				console.log('pathFirstWord', pathFirstWord, pathFirstWord === 'mentor',)

				let { type, operation } = this.currentInfo
				// if (operation !== 'edit') {
				// 	this.$message.error('请先保存模块')
				// 	return false
				// }
        let moduleTitles
				let { submodule_info } = this.cvDetail
        if (type === 'works') {
          if (this.cvDetail.basic_info.lang) {
            moduleTitles = this.section_titles['work'][this.cvDetail.basic_info.lang]
          } else {
            moduleTitles = null
          }
        } else if(type === 'edus') {
          if (this.cvDetail.basic_info.lang) {
            moduleTitles = this.section_titles['edu'][this.cvDetail.basic_info.lang]
          } else {
            moduleTitles = null
          }
        }
        // contentChooices = [
        //   { name: 'aaa', checked: false },
        //   { name: 'bbb', checked: false },
        //   { name: 'ccc', checked: false },
        // ]
				const alertData = {
					...this.alertData,
          moduleTitles,
					messageTitle: '修改模块名称',
					inputData: {
						show: true,
						length: 15,
						value: submodule_info[`${ type }_title`],
						showLength: true,
						placeholder: '请输入模块名称'
					},
					cancel: close => {
						close()
					},
					confirm: async (close, value) => {
						let payload = {
							submodule_info: {
								[`${ type }_title`]: value,
							},
							operation_type: 'update_submodule_info',
							not_need_default_error_tips: true
						}
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
							close()
							this.$message.success('修改成功')
							//更新经历库模块名称
							this.updateExperienceTitleName({ type, title: value })
							//整理模块管理模块选中状态
							this.getMenuList()
						} else {
							let errorMsg = res.message
							if (payload.not_need_default_error_tips && res.code === 80120) { // 未找到对应简历
								errorMsg = '请编辑简历后再修改'
							}
							this.$message.error(errorMsg)
						}
					}
				}
				this.setAlertData(alertData)
			},
			// 删除模块
			async deleteExperience () {
				const alertData = {
					...this.alertData,
					messageContent: `
          <p>删除后可以在页面右下角「经历库」内找回</p>
          <p style="color: #FF453E">确定删除本段经历吗?</p>
        `,
					confirm: async close => {
						let { data: { id }, type } = this.backUpInfo
						let { submodule_info, basic_info } = this.cvDetail
            let { sections_position } = submodule_info;
            let infos = [];
            let payload = null;
						let ids = submodule_info[`${ type }_ids`]
            // 当只有一条经历，删除该模块
            if(ids.length === 1){
              payload = {
                operation_type: 'update_submodule_info',
                submodule_info: {
                  sections_position: sections_position.filter(item => item.type != type),
                  [`${ type }_ids`]: []
                }
              }
            }else {
              infos = this[type].filter(item => item.id !== id)
              payload = {
                operation_type: 'update_submodule_info',
                submodule_info: {
                  [`${ type }_ids`]: ids.filter(i => i !== id)
                }
              }
            }

            if(basic_info.kind == 'sample' || basic_info.kind == 'template') {
              this.$message.error('请先编辑简历信息')
              return ;
            }
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
              // console.log(res)
							close()
							this.$message.success('删除成功')
							this.setModuleData({ type, info: infos })
							//删除经历库某个模块选中状态
							this.deleteExperienceSelect({ type, id })
							//重置
							this.resetEditState()
              this.getMenuList()
						} else {
							this.$message.error(res.message)
						}
					},
					cancel: close => {
						close()
					},
				}
				this.setAlertData(alertData)
			},
			//显示超出模块最大限制
			// showModuleMaxTips () {
			// 	console.log(this.alertData)
			// 	const alertData = {
			// 		...this.alertData,
			// 		messageTitle: '创建失败',
			// 		showCancelButton: false,
			// 		confirmButtonText: '前往经历库',
			// 		messageContent: `当前模块下经历数量已达到上限，请前往「经历库」，删除多余经历`,
			// 		confirm: async close => {
			// 			close()

      //       let arr = ['edus','orgs','works','extras','9905051','9905050','project_experience']
      //       let jumpParam = {type: this.currentInfo.type, index: arr.indexOf(this.currentInfo.type)}
      //       // 跳转到相应的经历库
      //       this.setCurrentInfo({
      //         operation: '',
      //         type: '',
      //         data: {}
      //       })
      //       setTimeout(()=>{
      //         this.updateSidebarOption('library')
      //         this.updateCurrentExperienceType(jumpParam)
      //       })
			// 		},
			// 		cancel: close => {
			// 			close()
			// 		},
			// 	}
			// 	this.setAlertData(alertData)
			// },
      //点击自动写简历开关
      handleClickAuto(bool){
        this.setAutoModel(bool)
			  if(bool){
          this.getPostLevelId({job_title: this.formData.title})
			    if(!this.formData.title){
            this.setIsShowAutoWriteError(true)
            this.setAutoModel(false)
            document.querySelector(".edit-module-index-main").scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          }
        }
      },
      //点击自动内容
      handleClickAutoContentItem(data){
			  if(this.isAutoWriteing) return;
			  this.isAutoWriteing = true
			  let { text } = data
        let newText = punctuationText(text)
        // let ieSelectionBookmark = tinymce.get('myEditor').selection.getBookmark
        tinymce.activeEditor.selection.moveToBookmark();

			  let i = 0
        let timer = setInterval(() => {
          tinymce.activeEditor.execCommand('mceInsertContent',false,newText[i])
          i++
          if(i >= newText.length){
            clearInterval(timer)
            setTimeout(()=>{
              this.isAutoWriteing = false
              this.oldContent = this.formData.description || ''
            },20)
          }
        },10)
      },
      updateForm(data){
			  this.formData[data.key] = data.value
      }
		},
    beforeDestroy() {
      this.setIsShowAutoWriteError(false)
      this.setAutoModel(false)
    }
  }
</script>
<style lang="scss" scoped>
  .edit-module-content-main {
    .auto-model{
      font-size: 14px;
      font-weight: 500;
      color: #404040;
      margin-right: 10px;
    }
    .form-box{
      height: auto;
      overflow: hidden;
      transition: all 300ms;
      &.hide{
        height: 0px;
      }
    }
    padding: 0 28px;
    .edu-menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edu-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        cursor: pointer;
        .edu-item-select {
          width: 16px;
          height: 16px;
          border: 1px solid #DEDFE1;
          margin-right: 12px;
          text-align: center;
          line-height: 16px;
          &.active {
            .iconfont {
              font-size: 14px;
              margin: auto;
            }
          }
        }
        .iconfont {
          margin-right: 8px;
        }
      }
    }
    .edit-module-name {
      span {
        display: inline-block;
        max-width: 80%;
      }
      i {
        margin-left: 6px;
      }
    }
    .common-container {
      color: #4183FF;
      .common-tips {
        margin-left: 6px;
      }
    }
    .common-disabled {
      color: #cfcfcf;
    }

    .ai-cvs-entry {
      width: 88px;
      background: #FF7557;
      border-radius: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 1;
      text-align: center;
      border: none;
      padding: 6px 0;
      &:hover {
        opacity: 0.8;
      }
    }

  }
</style>
